/* Optional outer shell — glow and shadow only; gradient background moved to button */
.shell {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  color: white;
  box-shadow: var(--ai-icon-shadow, 0 25px 50px -12px var(--primary-a6));
}

/* Soft variant: frosted white layer (gradient background handled by button) */
.shellFrosted {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.85) 100%);
}

.shellFit {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.shellGlow {
  position: absolute;
  inset: 0;
  background-color: var(--ai-icon-glow-color, var(--primary-a4));
  filter: blur(var(--ai-icon-glow-blur, 24px));
  border-radius: 50%;
  pointer-events: none;
}

.root {
  position: relative;
  display: block;
  flex-shrink: 0;
}

.rootFit {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.animLayer {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.star {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.star svg,
.centerStar svg {
  fill: var(--ai-sparkle-fill, currentcolor);
  stroke: var(--ai-sparkle-stroke, currentcolor);
}

.centerWrap {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  pointer-events: none;
}

.animLayer .centerStar {
  display: flex;
  width: 51.67%;
  height: 51.67%;
  align-items: center;
  justify-content: center;
  animation: center-star-anim-once 2.5s ease-in-out 1 forwards;
}

.centerStar svg {
  width: 100%;
  height: 100%;
  stroke-width: 1;
}

.animLayer .trStar {
  top: 16.67%;
  right: 16.67%;
  width: 25.83%;
  height: 25.83%;
  opacity: 0.9;
  animation: tr-star-anim-once 2.5s ease-in-out 1 forwards;
}

.trStar svg {
  width: 100%;
  height: 100%;
  stroke-width: 1.5;
}

.animLayer .blStar {
  bottom: 20.83%;
  left: 20.83%;
  width: 18.5%;
  height: 18.5%;
  opacity: 0.8;
  animation: bl-star-anim-once 2.5s ease-in-out 1 forwards;
}

.blStar svg {
  width: 100%;
  height: 100%;
  stroke-width: 2;
}

.animContinuous .centerStar {
  animation: center-star-anim-loop 2.5s ease-in-out infinite;
}

.animContinuous .trStar {
  animation: tr-star-anim-loop 2.5s ease-in-out infinite;
}

.animContinuous .blStar {
  animation: bl-star-anim-loop 2.5s ease-in-out infinite;
}

@keyframes center-star-anim-once {
  0% {
    transform: rotate(0deg) scale(1);
  }
  16% {
    transform: rotate(90deg) scale(1.2);
  }
  32% {
    transform: rotate(180deg) scale(1);
  }
  100% {
    transform: rotate(180deg) scale(1);
  }
}

@keyframes tr-star-anim-once {
  0%,
  32% {
    transform: scale(0) rotate(-45deg);
  }
  56%,
  100% {
    transform: scale(1) rotate(0deg);
  }
}

@keyframes bl-star-anim-once {
  0%,
  32% {
    transform: scale(0) rotate(45deg);
  }
  61%,
  100% {
    transform: scale(1) rotate(0deg);
  }
}

@keyframes center-star-anim-loop {
  0% {
    transform: rotate(0deg) scale(1);
  }
  16% {
    transform: rotate(90deg) scale(1.2);
  }
  32% {
    transform: rotate(180deg) scale(1);
  }
  100% {
    transform: rotate(180deg) scale(1);
  }
}

@keyframes tr-star-anim-loop {
  0%,
  32% {
    transform: scale(0) rotate(-45deg);
  }
  56%,
  72% {
    transform: scale(1) rotate(0deg);
  }
  88%,
  100% {
    transform: scale(0) rotate(45deg);
  }
}

@keyframes bl-star-anim-loop {
  0%,
  32% {
    transform: scale(0) rotate(45deg);
  }
  61%,
  77% {
    transform: scale(1) rotate(0deg);
  }
  93%,
  100% {
    transform: scale(0) rotate(-45deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .animLayer .centerStar,
  .animLayer .trStar,
  .animLayer .blStar {
    animation: none;
  }
}

.staticDecor .centerStar,
.staticDecor .trStar,
.staticDecor .blStar {
  animation: none !important;
}
